// episodes.js — Kingdom of Night episode data
// To add a new episode, add an object to this array.
// audioUrl: update with the correct Cloudflare R2 URL for each file.
// keeperId: must match an id in keepers.js

const BASE_URL = "https://pub-95c7415025df49ca87659ca0bd229f29.r2.dev";

const episodes = [
  {
    id: 1,
    slug: "night-mother",
    title: "The Night Mother Welcomes You",
    archetype: "The Night Mother",
    keeperId: "night-mother",
    theme: "Warmth & Belonging",
    intensity: "Moderate",
    description:
      "For when you need to feel less alone in the dark. Step into the Kingdom and find the Night Mother in her lantern-lit clearing — tending her garden, settling the little ones, simply present. Nothing is required of you here.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-NM-The-Night-Mother-Welcomes-You.mp3`,
  },
  {
    id: 2,
    slug: "keeper-of-lanterns",
    title: "Wander with the Keeper of Lanterns",
    archetype: "The Keeper of Lanterns",
    keeperId: "keeper-of-lanterns",
    theme: "A Quieting Mind",
    intensity: "Deep",
    description:
      "For when you need the busy day to quieten down. Follow the Keeper through the crossroads as they move through the Kingdom — lowering lanterns, tending the flock, closing each road gently in turn. Let them show you how a full night ends.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-KL-Wander-with-the-Keeper-of-Lanterns.mp3`,
  },
  {
    id: 3,
    slug: "tide-listener",
    title: "The Foreshore with the Tide Listener",
    archetype: "The Tide Listener",
    keeperId: "tide-listener",
    theme: "Release & Stillness",
    intensity: "Deep",
    description:
      "For when you need somewhere wide enough to put things down. Walk to the moonlit shore and sit with the Tide Listener. The ocean has received everything ever brought to this shore. It has never once turned anything away.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-TL-The-Foreshore-with-the-Tide-Listener.mp3`,
  },
  {
    id: 4,
    slug: "fire-keeper",
    title: "The Hearth of the Fire Keeper",
    archetype: "The Fire Keeper",
    keeperId: "fire-keeper",
    theme: "Rest & Warmth",
    intensity: "Deep",
    description:
      "For when you need to set something down and be warm for a while. Find the Fire Keeper's grove and let your pack be taken. The fire asks nothing of you. It simply burns — steady and unhurried.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-FK-The-Hearth-of-the-Fire-Keeper.mp3`,
  },
  {
    id: 5,
    slug: "dream-keeper",
    title: "The Workshop of the Dream Keeper",
    archetype: "The Dream Keeper",
    keeperId: "dream-keeper",
    theme: "Trust & Becoming",
    intensity: "Deep",
    description:
      "For when you need to trust that something is still becoming. Enter the Dream Workshop and watch something old being remade — not lost, only changing. What the river gives back, the fire deepens. Every piece finds its form in time.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-DK-The-Workshop-of-the-Dream-Keeper.mp3`,
  },
  {
    id: 6,
    slug: "garden-keeper",
    title: "The Garden of Solace",
    archetype: "The Garden Keeper",
    keeperId: "garden-keeper",
    theme: "Presence & Ease",
    intensity: "Deep",
    description:
      "For when you need somewhere to simply be. Follow the Garden Keeper through moonlit beds of lavender and sage — pausing for beetles, tending what leans, noticing what holds. The garden doesn't ask you to stop. It simply gives you somewhere to be.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-GK-The-Garden-of-Solace.mp3`,
  },
  {
    id: 7,
    slug: "sky-keeper",
    title: "The Sky Keeper's Open Horizons",
    archetype: "The Sky Keeper",
    keeperId: "sky-keeper",
    theme: "Perspective & Steadiness",
    intensity: "Deep",
    description:
      "For when you need the long view, and a sky wide enough to hold it. Climb to the plateau above the Kingdom and sit with the Sky Keeper beneath the full sky. The wandering constellation always arrives somewhere. The bright star always holds its place.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-SK-The-Sky-Keepers-Open-Horizons.mp3`,
  },
  {
    id: 8,
    slug: "night-mother-the-longest-night",
    title: "The Night Mother: The Longest Night",
    archetype: "The Night Mother",
    keeperId: "night-mother",
    theme: "Shelter & Endurance",
    intensity: "Deep",
    description:
      "For the nights when a storm has found you. The path is wet and the wind moves through the branches — but the Night Mother's cottage is lit at every window, and the door is open, as it always is. However you came to be here, in whatever weather, she has not waited to know. Come in.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-NM-The-Night-Mother-The-Longest-Night.mp3`,
  },
  {
    id: 9,
    slug: "garden-keeper-a-night-of-wonders",
    title: "The Garden Keeper: A Night of Wonders",
    archetype: "The Garden Keeper",
    keeperId: "garden-keeper",
    theme: "Wonder & Belonging",
    intensity: "Deep",
    description:
      "For the nights when something unexpected finds you. The garden is awake in the rain — the frogs in full conversation, the moonflowers open despite the weather, a platypus moving through the shallows with the air of someone who has been doing this since before the garden was a garden. The Garden Keeper knew tonight would be like this. Come in.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-GK-The-Garden-Keeper-A-Night-of-Wonders.mp3`,
  },
  {
    id: 10,
    slug: "keeper-of-lanterns-the-rounds",
    title: "The Keeper of Lanterns: The Rounds",
    archetype: "The Keeper of Lanterns",
    keeperId: "keeper-of-lanterns",
    theme: "Steadiness & Care",
    intensity: "Deep",
    description:
      "For the nights when a storm moves through and the world needs tending anyway. The Keeper of Lanterns is already at the crossroads — lantern in hand, dog at heel, making their rounds through rain-dark streets and gleaming stones. The work continues. The lights hold.",
    duration: "~45 min",
    audioUrl: `${BASE_URL}/KoN-KL-The-Keeper-of-Lanterns-Storm-The-Rounds.mp3`,
  },
  {
    id: 11,
    slug: "tide-listener-meeting-the-storm",
    title: "Meeting the Storm with the Tide Listener",
    archetype: "The Tide Listener",
    keeperId: "tide-listener",
    theme: "Presence & Certainty",
    intensity: "Deep",
    description:
      "For when something feels immense and you need to stand in it with someone who knows it will pass. Find the Tide Listener on the foreshore as a storm moves through — rain on your face, the ocean fully itself, a keeper who has stood in many storms and carries the certainty that the quiet always returns.",
    duration: "~54 min",
    audioUrl: `${BASE_URL}/KoN-TL-Tide-Listener-Storm-Meeting-The-Storm.mp3`,
  },
  {
    id: 12,
    slug: "fire-keeper-storms-passage",
    title: "The Fire Keeper: The Storm's Passage",
    archetype: "The Fire Keeper",
    keeperId: "fire-keeper",
    theme: "Shelter & Vigilance",
    intensity: "Deep",
    description:
      "For when you need somewhere the storm cannot reach. Find the Fire Keeper's grove tonight — the canopy holds, the fire burns generous and unhurried, and whoever else has come in from the rain is already making room. Nothing outside this ring changes anything about the welcome inside it.",
    duration: "~65 min",
    audioUrl: `${BASE_URL}/KoN-FK-The-Fire-Keeper-Storms-Passage.mp3`,
  },
];

export default episodes;
